import { styled } from "@styles";

export const Wrapper = styled.div``;

export const Title = styled.h1`
  text-align: center;
  font-size: 1.3rem;
`;
